import styled from 'styled-components';

import { mediaQueries } from '../../styles/media';

export const Container = styled.div`
  height: inherit;
`;

export const Content = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  svg {
    max-width: 200px;
    align-self: baseline;
    position: absolute;
    top: 20px;
    left: 20px;

    ${mediaQueries('small')`
      max-width: 100%;
      top: 50px;
    `}
  }
`;

export const Title = styled.h3`
  font-family: 'Montserrat Bold';
  font-size: 28px;
  line-height: 38px;
  color: #f12b2c;
  margin-bottom: 20px;
  margin-top: 100px;
  max-width: 240px;
  text-align: center;

  ${mediaQueries('medium')`
    font-size: 32px;
    line-height: 42px;
    max-width: 260px;
  `}
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 28px;
  color: #25282b;
  text-align: center;

  ${mediaQueries('small')`
    font-size: 20px;
    line-height: 32px;
    max-width: 278px;
  `}
`;
